import { formularioRegistroBienCultural } from "./registro-bien-cultural.model"
import { Tipologia, TipologiasInterface } from "./tipologias.model"

export class RegistroBienInmueble {
  tipoBien: TipologiasInterface
  tipoPropiedad:TipologiasInterface
  nombre: string
  seccion: TipologiasInterface
  coleccion: TipologiasInterface
  departamento: TipologiasInterface
  municipio: TipologiasInterface
  titular: TipologiasInterface
  propietario: string
  poseedor: string
  finca: string
  folio: string
  libro: string

  constructor(myForm:formularioRegistroBienCultural){

    this.tipoBien = { tipologiaId: myForm.tipoDeBien, tipologiaPadreId: 0, descripcion: '', valor1: '', valor2: '', valor3: '', tipologias:null };
    this.tipoPropiedad = { tipologiaId: myForm.tipoPropiedad, tipologiaPadreId: 0, descripcion: '', valor1: '', valor2: '', valor3: '', tipologias:null };
    this.nombre = myForm.nombre;
    this.seccion = { tipologiaId: myForm.seccion, tipologiaPadreId: 0, descripcion: '', valor1: '', valor2: '', valor3: '', tipologias:null };
    this.coleccion = { tipologiaId: myForm.coleccion.tipologiaId , tipologiaPadreId: 0, descripcion: '', valor1: myForm.coleccion.valor1, valor2: '', valor3: '', tipologias:null };
    this.departamento = { tipologiaId: myForm.departamento.tipologiaId, tipologiaPadreId: 0, descripcion: '', valor1:  myForm.departamento.valor1, valor2: '', valor3: '', tipologias:null };
    this.municipio = { tipologiaId: myForm.municipio.tipologiaId, tipologiaPadreId: 0, descripcion: '', valor1: myForm.municipio.valor1, valor2: '', valor3: '', tipologias:null };
    this.titular = { tipologiaId: myForm.titular, tipologiaPadreId: 0, descripcion: '', valor1: '', valor2: '', valor3: '', tipologias:null };
    this.propietario= myForm.propietarioNombre
    this.poseedor= myForm.nombrePoseedor
    this.finca=myForm.finca
    this.folio= myForm.folio
    this.libro= myForm.libro
}

}
